import { render, staticRenderFns } from "./FlashCardLanding.vue?vue&type=template&id=578c6f1c&"
import script from "@/scripts/FlashCard/FlashCardLanding/index.js?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardLanding/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports